import type { Market } from '@backmarket/http-api'

type ValidationResponse = {
  success: boolean
}

export function validateAllowedUsersByCountry({
  allowedUsersByCountry,
  countryCode,
  userId,
}: {
  allowedUsersByCountry: string
  countryCode: Market['countryCode']
  userId: number | undefined
}): ValidationResponse {
  if (typeof allowedUsersByCountry !== 'string') {
    return { success: false }
  }

  const countryRules: Record<string, string> = {}

  for (const allowedUsers of allowedUsersByCountry.split(';')) {
    const [country, users] = allowedUsers.split(':')

    if (country && users) {
      countryRules[country.trim().toUpperCase()] = users.trim()
    }
  }

  const userListForCountry = countryRules[countryCode]

  if (!userListForCountry) {
    return { success: false }
  }

  if (userListForCountry === 'all') return { success: true }

  if (userListForCountry === userId?.toString()) return { success: true }

  const isUserInList = userListForCountry
    .split(',')
    .map((id) => id.trim())
    .includes(userId?.toString() ?? '')

  if (isUserInList) return { success: true }

  return { success: false }
}
